/* eslint-disable global-require */
import { getEnvParam } from 'env'

const configMap = {}

export default function appTypeConfigFunc() {
  let appTypeInfo = {};
  try {
    appTypeInfo = JSON.parse(getEnvParam('appType') || '{}');
  } catch {
    appTypeInfo = {};
  }

  let appType = appTypeInfo.role;
  if (appTypeInfo.enableChat !== true) {
    appType = 'no-chat';
  }

  if (configMap[appType] == null) {
    const config = {}

    // console에서는 workspace.role을 기준으로 구분.
    switch (appType) {
      case 'owner':
      case 'admin':
        config.menu = require('./admin/menu').default
        config.router = require('./admin/router').default
        config.config = require('./admin/config').default
        break
      case 'no-chat':
        config.menu = require('./admin-no-chat/menu').default
        config.router = require('./admin-no-chat/router').default
        config.config = require('./admin-no-chat/config').default
        break
      default:
        config.menu = () => []
        config.router = () => []
        config.config = {
          defaultPage: '/',
        }
    }

    configMap[appType] = config
  }

  return configMap[appType]
}
